import { Stack, Box, IconButton } from "@mui/material"
import DownIcon from '@mui/icons-material/KeyboardArrowDown';
import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import Check from "./Check";
import Section from "./Section";
import Collapse from '@mui/material/Collapse';
import useCourse from "../Hooks/useCourse";

export default function Chapter({chapter, open, onToggle}){

    const course = useCourse();

    const completed = chapter.sections.filter(s => s.completed).length === chapter.sections.length;

    return <>

        <article className='study-chapter' data-id={chapter.id} onClick={onToggle}>

            <Stack direction='row' alignItems='center' spacing={1}>

                <Check value={completed}/>
            
                <Box>{chapter.title}</Box>

            </Stack>
            
            <IconButton size='small' sx={{ml: '2px'}}>

                {open ? <UpIcon /> : <DownIcon />}

            </IconButton>
            
        </article>


        <Collapse in={open}>

            {chapter.sections.map(s => 
                <Section 
                    section={s}
                    course={course}
                    key={s.id}
                />
            )}
        
        </Collapse>

    </>
}